import withTranslation from '../../../../../globals/components/withTranslation'
import Component from './compotent'

export default withTranslation(Component)
